import constants from '../constants/index';
import normalize from '../lib/normalize';

const defaultState = normalize({selected: ['all']}, [
  { 
    id: 'reading_intervention',
    name: 'Reading Intervention',
    selectedClass: 'abl-student-cohorts-reading-intervention',
    students: [0,1,2,3,4,5,6,7,8,9,10]
  },
  { 
    id: 'ell',
    name: 'ELL',
    selectedClass: 'abl-student-cohorts-ell',
    students: [10, 11, 12, 13, 14]
  },
  { 
    id: 'iep_special_ed',
    name: 'IEP / Special Ed',
    selectedClass: 'abl-student-cohorts-iep',
    students: [21, 22, 23, 24]
  },
  { 
    id: 'math_intervention',
    name: 'Math Intervention',
    selectedClass: 'abl-student-cohorts-math-intervention',
    students: [15, 16, 17, 18, 19, 20]
  }
]);

export default function studentCohortsFiltersReducer(state = defaultState, action) {
  let newState = state;

  switch(action.type) {
    case constants.CHANGE_STUDENT_COHORT_FILTER:
      if(action.payload.selected) {
        newState = Object.assign({}, newState, {
          selected: [action.payload.id]
        });  
      }
      else {
        newState = Object.assign({}, newState, {
          selected: []
        });
      }
      break;
    case constants.SELECT_VIEWER_CELL:
      newState = Object.assign({}, newState, {
        selected: []
      });
      break;
    default: 
  }

  return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/student_cohort_filters_reducer.js
 **/